"use client"

import { motion } from "framer-motion"

interface SectionHeroProps {
  title: string
  subtitle?: string
  description?: string
}

export const SectionHero = ({ title, subtitle, description }: SectionHeroProps) => {
  return (
    <section className="bg-gradient-to-br from-slate-900 to-slate-800 py-16 text-white md:py-20">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h1 className="mb-4 text-3xl font-bold leading-tight sm:text-4xl md:mb-6 md:text-5xl lg:text-6xl">{title}</h1>
          {subtitle && (
            <p className="mx-auto mb-4 max-w-3xl text-base text-teal-300 sm:text-lg md:mb-6 md:text-xl">{subtitle}</p>
          )}
          {description && (
            <p className="mx-auto max-w-3xl text-base text-slate-300 sm:text-lg md:text-xl">{description}</p>
          )}
        </motion.div>
      </div>
    </section>
  )
}

export default SectionHero
